import React from "react";
import { Link } from "react-router-dom";

export const DALLAS_SCAN_URL =
  "https://www.jiffy.com/supplier/scan?t=eyJzdG9ja19sb2NhdGlvbl9pZCI6MTE5MCwiZ2VuZXJhdGlvbiI6MH0%3D--a8e7bb1d60216a7be546393203f01465e4d8b433";

export const DALLAS_SOP_URL =
  "https://drive.google.com/file/d/1vya-zr90DmZMluhnizlxoXnVjqQ2ns7S/view";

const handleDallasLogout = () => {
  if (!window.confirm("Are you sure you want to logout?")) return;
  localStorage.removeItem("token");
  localStorage.removeItem("email");
  window.location.href = "/";
};

const DallasShopNav = ({ active = "orders" }) => {
  const title =
    active === "inventory"
      ? "Dallas Inventory"
      : active === "assembly"
        ? "Dallas Assembly"
        : "Dallas Orders";

  return (
    <>
      <div className="text-center mb-3">
        <button
          className="btn btn-outline-danger mt-2"
          onClick={handleDallasLogout}
        >
          Logout
        </button>
        <h2 className="mt-2 mb-2">{title}</h2>
        <div className="btn-group flex-wrap">
          <Link
            className={`btn ${
              active === "orders" ? "btn-primary" : "btn-outline-primary"
            }`}
            to="/dallas-orders"
          >
            Dallas Orders
          </Link>
          <Link
            className={`btn ${
              active === "assembly" ? "btn-primary" : "btn-outline-primary"
            }`}
            to="/dallas-assembly"
          >
            Dallas Assembly
          </Link>
          <Link
            className={`btn ${
              active === "inventory" ? "btn-primary" : "btn-outline-primary"
            }`}
            to="/dallas-inventory"
          >
            Inventory
          </Link>
        </div>
      </div>

      {active !== "assembly" ? (
        <div className="alert alert-light border d-flex flex-wrap justify-content-between align-items-center gap-2">
          <div>
            <strong>Jiffy dock scan</strong>
            <div className="small text-muted mb-0">
              Chrome or Edge only. Scan the large UPS TRACKING # barcode. Green
              check on the page is the real confirmation.
            </div>
          </div>
          <div className="d-flex gap-2">
            <a
              className="btn btn-sm btn-outline-primary"
              href={DALLAS_SCAN_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Open scan page
            </a>
            <a
              className="btn btn-sm btn-outline-secondary"
              href={DALLAS_SOP_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Setup SOP
            </a>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default DallasShopNav;
